<template>
  <div class="password-modal">
    <div class="password-modal-body">
      <div class="password-body">
        <div class="password-body-title">
          <p>Нэвтрэх нууц үг солих</p>
        </div>
        <div class="password-body-form">
          <form action="" @submit.prevent="sendNumber">
            <input
              type="password"
              placeholder="шинэ нууц үг"
              v-model="npassword"
            />
            <input
              type="password"
              placeholder="ДАВТАН НУУЦ ҮГ"
              v-model="rpassword"
              style="margin-top: 12px"
            />
            <div class="password-error" v-if="error">
              <p>{{ errorMessage }}</p>
            </div>
            <input
              type="submit"
              value="Хадгалах"
              class="btn login-btn"
              :class="{ someSpace: error }"
            />
          </form>
        </div>
      </div>
      <div class="password-footer">
        <p>Дараагийн удаа веб-д нэвтрэх нууц үгээ тохируулна уу.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["password"],
  data() {
    return {
      npassword: "",
      rpassword: "",
      error: false,
      errorMessage: "",
      isDisabled: false,
    };
  },
  methods: {
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    sendNumber() {
      var newPassword = this.npassword;
      var rPassword = this.rpassword;
      var oldPassword = "passwordconfirm";
      if (newPassword.length >= 8) {
        if (newPassword === rPassword) {
          //lowercase,uppercase,digits,special digits
          let isCheckPassword =
            /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,25}$/.test(
              newPassword
            );
          if (isCheckPassword) {
            var tokenId = localStorage.getItem("authToken");
            var user = this.$auth.getMe();
            if (tokenId == null || user == null) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
            var cardHolderInfId = user.cardHolderInfId;
            this.$axiosApi
              .post(`system/forgotpassword/changepassword`, {
                tokenId,
                cardHolderInfId,
                oldPassword,
                newPassword,
              })
              .then((response) => {
                if (response.data.status === 0) {
                  this.nPassword = "";
                  this.rPassword = "";
                  this.$emit("closePassword");
                }
              })
              .catch((error) => {
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
                this.$insProgress.finish();
              });
          } else {
            this.errorMessage =
              "Таны оруулсан нууц үг том, жижиг үсэг, тоо, тусгай тэмдэгт /!@#$%^&*/ агуулсан байна!";
            this.error = true;
          }
        } else {
          this.errorMessage = "Таны оруулсан нууц үг хоорондоо ижил биш байна.";
          this.error = true;
        }
      } else {
        this.errorMessage = "Та хамгийн багадаа 8 оронтой нууц үг оруулна уу.";
        this.error = true;
      }
    },
  },
};
</script>

<style scoped>
.password-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.5);
}
.password-modal-body {
  z-index: 5000;
  position: absolute;
  width: 436px;
  height: auto;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.password-close {
  padding-left: 54px;
  margin-top: 30px;
  padding-right: 30px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.password-close img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.password-body {
  margin-top: 49px;
}
.password-body-title {
  padding-left: 54px;
  width: 100%;
}
.password-body-title p {
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.password-body-form {
  padding-left: 54px;
  width: 100%;
  margin-top: 29px;
}
.password-body-form form {
  padding-right: 53px;
  display: flex;
  flex-direction: column;
}
.password-body-form form input[type="password"] {
  border-radius: 5px;
  height: 37px;
  background-color: #ebebeb;
  outline: none;
  border: none;
  font-size: 11px;
  padding-left: 15px;
}
.password-body-form form input[type="password"]::placeholder {
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 4.09;
  letter-spacing: 0.3px;
  text-align: left;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
}
.password-body-form form input[type="submit"] {
  margin-top: 19px;
  width: 50%;
  height: 38px;
  border-radius: 5px;
  background-color: #1660ab;
  outline: none;
  border: none;
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  color: #ffffff;
  cursor: pointer;
  text-transform: uppercase;
}
.someSpace {
  margin-top: 2px !important;
}
.password-footer {
  margin-top: 50px;
  height: 103px;
  width: 100%;
  background-color: #1660ab;
  display: flex;
  align-items: center;
}
.password-footer p {
  padding-left: 53px;
  padding-right: 55px;
  margin-bottom: 0;
  font-size: 12.1px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.49;
  text-align: center;
  letter-spacing: normal;
  color: rgba(255, 255, 255, 0.8);
}
.password-error {
  width: 100%;
  height: auto;
}
.password-error p {
  margin-bottom: 0;
  font-size: 11px;
  color: #ed3237;
}
@media screen and (max-width: 500px) {
  .password-modal-body {
    height: auto;
  }
  .password-close {
    margin-top: 20px;
    padding-right: 15px;
  }
  .password-close img {
    width: 15px;
    height: 15px;
  }
  .password-body {
    margin-top: 20px;
  }
  .password-body-title,
  .password-body-form {
    padding-left: 20px;
  }
  .password-body-title {
    padding-right: 20px;
  }
  .password-body-title p {
    font-size: 18px;
  }
  .password-body-form {
    margin-top: 10px;
  }
  .password-footer p {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 10px;
  }
  .password-body-form form {
    padding-right: 20px;
  }
  .password-body-form form input[type="submit"] {
    height: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 11px;
  }
  .password-body-form form input[type="text"] {
    padding-left: 10px;
    padding-right: 10px;
  }
  .password-footer {
    height: 80px;
  }
}
@media screen and (max-width: 800px) {
  .password-modal-body {
    width: 80%;
  }
  .password-body-form form input[type="submit"] {
    width: auto;
  }
  .password-body-title {
    padding-right: 53px;
  }
}
</style>
